import React from 'react'
import ReactDOM from 'react-dom'

import ModalInner, {Props} from './ModalInner'

export default function Modal(props: Props) {
  return ReactDOM.createPortal(<ModalInner {...props} />, document.querySelector('#modal-root'))
}
